import { Field, useField } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import SelectSearch from 'react-select';

const CustomSelect = ({
	customOnChange = null,
	field,
	form,
	is_multi = false,
	options,
	variant,
}) => {
	const [isMounted, setIsMounted] = useState(false);

	useEffect(() => setIsMounted(true), []);

	const getValue = () => {
		if (options) {
			return is_multi
				? options.filter((option) => field.value.indexOf(option.value) >= 0)
				: options.find((option) => option?.value === field?.value);
		} else {
			return is_multi ? [] : '';
		}
	};

	const onChange = (option) => {
		if (customOnChange) customOnChange({ form, ...option });
		form.setFieldValue(
			field.name,
			is_multi ? option.map((item) => item.value) : option.value,
		);
	};

	const controlClassName = (state) => {
		if (variant === 'clean') {
			return state.isFocused
				? 'bg-white border-0 rounded-2'
				: 'bg-white border-0 rounded-2';
		} else if (variant === 'bordered') {
			return state.isFocused
				? 'border-gray-800 rounded-2 bg-white'
				: 'border-gray-400 rounded-2 bg-white';
		} else {
			return state.isFocused
				? 'border-gray-800 bg-white'
				: 'border-gray-200 bg-gray-200';
		}
	};

	return isMounted ? (
		<SelectSearch
			classNames={{
				control: controlClassName,
			}}
			isMulti={is_multi}
			name={field.name}
			onChange={onChange}
			options={options}
			theme={(theme) => ({
				...theme,
				borderRadius: 0,
				colors: {
					...theme.colors,
					primary: 'black',
					primary25: 'lightgray',
				},
			})}
			value={getValue()}
		/>
	) : null;
};

const Select = ({ className = null, hideLabel = false, ...props }) => {
	const [field, meta] = useField(props);

	return (
		<div className={`${className}`}>
			{!hideLabel && (
				<label className="form-label xs" htmlFor={props.id}>
					{props.placeholder}
				</label>
			)}

			<Field component={CustomSelect} {...field} {...props} />
			{meta.error && meta.touched ? (
				<div className="invalid-feedback d-block">{meta.error}</div>
			) : null}
		</div>
	);
};

CustomSelect.propTypes = {
	customOnChange: PropTypes.func,
	field: PropTypes.object,
	form: PropTypes.object,
	is_multi: PropTypes.bool,
	options: PropTypes.array,
	placeholder: PropTypes.string,
	variant: PropTypes.string,
};

Select.propTypes = {
	children: PropTypes.array,
	className: PropTypes.string,
	hideLabel: PropTypes.bool,
	id: PropTypes.string,
	options: PropTypes.array,
	placeholder: PropTypes.string,
};

export default Select;
